<template>
  <div :class="computedClass">
    <div :class="$style.left" data-qa="alert-left">
      <div :class="$style.icon" data-qa="icon">
        <slot name="icon" />
      </div>
      <div data-qa="caption">
        <slot />
      </div>
    </div>
    <div :class="$style.right" data-qa="alert-right">
      <slot name="right" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCssModule, computed } from 'vue';

const { size = 'm', align = 'center', type } = defineProps<{
  type: 'success' | 'info' | 'warning' | 'danger';
  size?: 's' | 'm';
  align?: 'center' | 'start';
}>();

const css = useCssModule();

const computedClass = computed(() => {
  return {
    [css.container]: true,
    [css[`type-${type}`]]: true,
    [css[`size-${size}`]]: true,
    [css[`align-${align}`]]: true
  };
});
</script>

<style module>
.container {
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border: 1px solid;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.align-center {
  align-items: center;
}
.align-start {
  align-items: flex-start;
}
.type-success {
  color: #00972d;
  border-color: #18bf5529;
  background-color: #18bf550a;
  .icon {
    color: #18bf55;
  }
}
.type-info {
  border-color: $gray-200;
  background-color: $gray-100;
  .icon {
    color: #949494;
  }
}
.type-warning {
  color: $red-600;
  border-color: $red-100;
  background-color: $red-50;
  .icon {
    color: #ff0000;
  }
}
.type-danger {
  color: $white;
  border-color: $red-400;
  background-color: $red-400;
  .icon {
    color: $white;
  }
}
.size-s {
  border-radius: 8px;
  padding: 8px 16px;
  .left {
    gap: 8px;
  }
}
.size-m {
  border-radius: 12px;
  padding: 14px 16px;
  .left {
    gap: 12px;
  }
}

.left {
  flex: 1 0 0;
  display: flex;
  align-items: inherit;
}
.right {
  flex: 0 0 auto;
}
.icon {
  flex: 0 0 auto;
  display: inline-flex;
}
</style>

<i18n lang="json">{}</i18n>
